import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";

import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const StoreVisits = () => {
  return (
    <>
      {/* <Card className="card-height-100" style={{ height: "270px" }}>
        <div className="card-body justify-content-center text-center">
          <div style={{ width: 127, height: 127 }} className="mx-2">
            <h6 className="text-center fw-bold fs-12 p-2">Document Storage</h6>
            <CircularProgressbar
              value={25}
              text={`${25}%`}
              styles={{
                path: {
                  width: "35px",
                  stroke: "#74C990",
                },
                text: {
                  fontSize: "15px",
                  fontWeight: "bold",
                  fill: "black",
                },
              }}
            />
            <h6 className="text-center fw-bold fs-11 pt-4">
              5 GB of 500 GB used
            </h6>
            <p className="text-center text-muted" style={{ fontSize: "10px" }}>
              Total file number: 11
            </p>
          </div>
        </div>
      </Card> */}

      <Card>
        <CardBody
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <Row className="justify-content-center">
            <h6 className="text-center fw-bold fs-12 p-4">Document Storage</h6>
          </Row>
          <Row
            // className="justify-content-center mw-25"
            style={{
              maxWidth: "200px",
            }}
          >
            <CircularProgressbar
              value={25}
              text={`${25}%`}
              styles={{
                path: {
                  stroke: "#74C990",
                },
                text: {
                  fontSize: "15px",
                  fontWeight: "bold",
                  fill: "black",
                },
              }}
            />
          </Row>
          <Row className="justify-content-center">
            <h6 className="text-center fw-bold fs-11 pt-3">
              5 GB of 500 GB used
            </h6>
            <p className="text-center text-muted" style={{ fontSize: "10px" }}>
              Total file number: 11
            </p>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default StoreVisits;
